import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import { useFloating, offset, flip, size, autoUpdate } from '@floating-ui/react';
import PropTypes from 'prop-types';
import { PLACEMENT_MAPPING } from '../../Utils/constant';
import { isRangeSelectionDatePicker } from '../utils/helper';
export const DatepickerContext = /*#__PURE__*/React.createContext();

// eslint-disable-next-line react/display-name
export const DatepickerProvider = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    type,
    month,
    isOpen,
    locale,
    children,
    withInput,
    setIsOpen,
    dateFormat,
    handleOnClose,
    handleResetClick,
    placeholder,
    setDisableConfirmButton,
    setMonth,
    disabled,
    placement,
    zIndex,
    disablePlacementFlip
  } = props;
  const datepickerContainerRef = useRef(null);
  const datepickerTriggerRef = useRef(null);
  const isRangeDatePicker = isRangeSelectionDatePicker(type);
  const {
    refs,
    context,
    floatingStyles
  } = useFloating({
    placement: PLACEMENT_MAPPING[placement] || 'bottom-start',
    open: isOpen,
    //onOpenChange: setIsOpen,
    whileElementsMounted: autoUpdate,
    middleware: [offset(8), flip(disablePlacementFlip ? {
      mainAxis: false,
      crossAxis: false
    } : {
      padding: 10
    }), size({
      apply(_ref) {
        let {
          elements,
          availableHeight
        } = _ref;
        Object.assign(elements.floating.style, {
          maxHeight: `${availableHeight}px`,
          zIndex: zIndex,
          // overflow: 'auto',
          borderRadius: '8px'
        });
      }
    })]
  });
  useImperativeHandle(ref, () => ({
    getTriggerRef: () => refs.setReference
  }));
  return /*#__PURE__*/React.createElement(DatepickerContext.Provider, {
    value: {
      type,
      month,
      isOpen,
      locale,
      withInput,
      setIsOpen,
      dateFormat,
      handleOnClose,
      handleResetClick,
      isRangeDatePicker,
      setDisableConfirmButton,
      datepickerContainerRef,
      datepickerTriggerRef,
      placeholder,
      setMonth,
      disabled,
      floatingUiProps: {
        refs,
        context,
        floatingStyles
      }
    }
  }, children);
});
DatepickerProvider.propTypes = {
  type: PropTypes.string.isRequired,
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  handleOnClose: PropTypes.func.isRequired,
  month: PropTypes.instanceOf(Date),
  handleResetClick: PropTypes.func.isRequired,
  setDisableConfirmButton: PropTypes.func.isRequired,
  dateFormat: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  withInput: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  placement: PropTypes.oneOf(['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight']),
  setMonth: function (props, propName) {
    if (props['type'] && isRangeSelectionDatePicker(props['type']) && typeof props[propName] !== 'function') {
      return new Error(`prop ${propName} type of function must be supplied when using range picker.`);
    }
  },
  zIndex: PropTypes.string,
  disablePlacementFlip: PropTypes.bool
};